import Admin from "./adminMethods";
import Issuer from "./issuerMethods";
import Public from "./publicMethods";

const _ = {
  Admin,
  Issuer,
  Public,
};

export default _;
